var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-wrapper",attrs:{"tabindex":"-1"}},[_c('el-tooltip',{attrs:{"popper-class":"tooltip-width","placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.data)+" ")]})],2),_c('el-button',[_vm._v("?")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }